import Implement from 'components/Implement';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const AccountPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <Implement>
        <div data-testid={testId}>Account Page</div>
    </Implement>
);

export default AccountPage;
